import { PageCrumbs } from '@platform/engine/list/header/PageCrumbs';
import { useFormEditor } from './form/useFormEditor';
import type { ISettingsFormPageProps } from './ISettingsFormPageProps';
import { SettingsFormEditor } from './SettingsFormEditor';
import { SettingsFormHead } from './SettingsFormHead';

/**
 * Редактор форми типу записів (прототип v4 page==='cust-form'): з меню модуля (inMod) — на маршруті модуля, з «Налаштування › Форми» — у
 * розділі «Налаштування» (CustomizeModulePage), на рівні «Глобально» — глобальна форма (ADR-027). Смуга крихт, далі колонка, що прокручується
 * разом із шапкою (24px 32px 48px, проміжок 16px): шапка форми з поверненням контексту (`links`) і редактор (зміни зберігаються
 * перевизначенням свого рівня одразу).
 */
export function SettingsFormPage({ ws, module, rt, name, crumbs, links, global = false }: ISettingsFormPageProps) {
  const editor = useFormEditor(ws, module, rt, global);
  return (
    <div className="lv-page">
      <PageCrumbs items={crumbs} />
      <div className="st-bp st-fpage">
        <SettingsFormHead ws={ws} module={module} rt={rt} name={name} editor={editor} links={links} />
        <SettingsFormEditor rt={rt} editor={editor} />
      </div>
    </div>
  );
}
